import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';
import { UpdateEmailAddressService } from './update-email-address.service';
// import 'rxjs/add/operator/takeUntil';
import { SelectedCountry } from '../models/selected-country';
import $ from 'jquery';
import 'bootstrap';
import { Modal } from 'bootstrap';

@Component({
    selector: 'app-update-email-address',
    templateUrl: './update-email-address.component.html',
    styleUrls: ['./update-email-address.component.css'],
    providers: [UpdateEmailAddressService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpdateEmailAddressComponent implements OnChanges {
  @Input() countryDetails: SelectedCountry;
  @Output() updatedEmail = new EventEmitter<any>();
  newEmail: string = '';
  errorMessage: string = '';
  showError: boolean = false;
  private readonly subscription: Subject<void> = new Subject<void>();
  constructor(private readonly updateEmailService: UpdateEmailAddressService) {}

  ngOnChanges() {
    this.newEmail = '';
    this.showError = false;
  }

  onSave() {
    const emailPattern = /^[A-Z0-9._%!'+-]+@([A-Z0-9-]+\.)+[A-Z]{2,10}$/i;
    const deloitte = /@deloitte/;
    if (!this.newEmail) {
      this.errorMessage = 'Please enter a valid email';
      this.showError = true;
    } else if (!emailPattern.test(this.newEmail)) {
      this.errorMessage = 'Email address is not valid';
      this.showError = true;
    } else if (!deloitte.test(this.newEmail.toLowerCase())) {
      this.errorMessage = 'Please enter a valid Deloitte email address';
      this.showError = true;
    } else if (
      this.newEmail &&
      this.countryDetails.userEmailSelected &&
      this.newEmail.toLowerCase() ===
        this.countryDetails.userEmailSelected.toLowerCase()
    ) {
      this.errorMessage = 'The email address is already in use';
      this.showError = true;
    } else {
      const countryDetailsObj = {
        CountryId: this.countryDetails.countryIdSelected,
        NewCountryMailbox: this.newEmail,
      };
      this.updateEmailService
        .saveNewEmail(countryDetailsObj)
        .subscribe((res) => {
          if (res.Message === 'Data sent successfully.') {
            this.updatedEmail.emit(countryDetailsObj);
            const modalElement = document.getElementById('saved_search_Modal');
            if (modalElement) {
              const modalInstance =
                Modal.getInstance(modalElement) || new Modal(modalElement);
              modalInstance.hide();
            }
            //   $("#saved_search_Modal").modal("hide");
          } else {
            alert('There was an error');
          }
        });
    }
  }

  ngOnDestroy() {
    this.subscription.next();
    this.subscription.complete();
  }
}
